<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-unencrypted`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31.68 29.04c.177.054.324.135.639.45l4.75 4.75 4.75-4.75c.316-.315.463-.396.64-.45a.908.908 0 01.534 0c.177.054.324.135.64.45l1.015 1.016c.315.315.397.462.45.64a.908.908 0 010 .534c-.053.177-.135.324-.45.639l-4.75 4.75 4.75 4.75c.315.316.397.463.45.64a.908.908 0 010 .534c-.053.177-.135.324-.45.64l-1.015 1.015c-.316.315-.463.397-.64.45a.908.908 0 01-.534 0c-.177-.053-.324-.135-.64-.45l-4.75-4.75-4.75 4.75c-.315.315-.462.397-.64.45a.908.908 0 01-.534 0c-.177-.053-.324-.135-.639-.45l-1.015-1.015c-.316-.316-.397-.463-.45-.64a.908.908 0 010-.534c.053-.177.134-.324.45-.64l4.75-4.75-4.75-4.75c-.316-.315-.397-.462-.45-.64a.908.908 0 010-.534c.053-.177.134-.324.45-.639l1.015-1.015c.315-.316.462-.397.64-.45a.908.908 0 01.534 0zM24 4c5.979 0 10.843 4.765 10.996 10.711L35 15v1h7c1.055 0 1.918.82 1.995 1.851L44 18v7h-4v-5H8v20h17v4H6a2.003 2.003 0 01-1.995-1.851L4 42V18c0-1.05.815-1.918 1.85-1.994L6 16h7v-1c0-6.08 4.925-11 11-11zm0 4c-3.785 0-6.87 3-6.996 6.76L17 15v1h14v-1c0-3.87-3.134-7-7-7z"/></svg>
</template>
<script>

export default {
  name: 'IconUnencrypted',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
